export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10101.cfbe0be5.jpg";